import React, { useEffect, useRef, useState } from 'react';
import video from './img/video_pc.mp4';
import poster from './img/immagine_poster.png';

const DesktopVideo = () => {
  const [ready, setReady] = useState(false);
  const videoRef = useRef(null);

  // Preload hint for the video file to reduce initial stall
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'video';
    link.href = video;
    link.type = 'video/mp4';
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  const onReady = () => {
    if (!ready) setReady(true);
    if (videoRef.current) {
      // Ensure autoplay is attempted once ready
      videoRef.current.play?.().catch(() => {});
    }
  };

  return (
    <div className="h-screen w-screen relative overflow-hidden">
      {/* Poster overlay to avoid the gray flash before the first frame */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${poster})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundColor: '#000',
          opacity: ready ? 0 : 1,
          transition: 'opacity 300ms ease',
          willChange: 'opacity',
          zIndex: 1,
        }}
      />

      <video
        ref={videoRef}
        src={video}
        playsInline
        autoPlay
        muted
        loop
        preload="auto"
        poster={poster}
        onCanPlay={onReady}
        onLoadedData={onReady}
        className="h-full w-full object-cover"
        style={{ backgroundColor: '#000' }}
      />
    </div>
  );
};

export default DesktopVideo;
